import React from 'react';
import Layout from '../components/layout/Layout';
import SummaryReportForm from '../components/reports/SummaryReportForm';

const SummaryReportPage = () => {
  return (
    <Layout>
      <SummaryReportForm />
    </Layout>
  );
};

export default SummaryReportPage;
